import { AlertTriangle } from "lucide-react";

/**
 * Insurance / dispute warning banner.
 *
 * Reused verbatim in the booking dialog, the customer-facing pay page, and
 * anywhere else we handle money outside the standard booth-fee flow. Copy
 * matches the language sent in the quote email (email_service.py) so the
 * promise a payer sees on the web is the promise they see in their inbox.
 *
 * Props:
 *   compact — smaller variant for tight cards; default is prominent.
 */
export default function InsuranceWarningBanner({ compact = false }) {
  const py = compact ? "p-3" : "p-4";
  const size = compact ? "text-xs" : "text-sm";
  return (
    <div
      className={`rounded-md border ${py} flex items-start gap-3`}
      style={{
        backgroundColor: "#fef3f2",
        borderColor: "rgba(249,115,22,0.35)",
      }}
      data-testid="insurance-warning-banner"
    >
      <AlertTriangle
        className={compact ? "h-4 w-4 mt-0.5" : "h-5 w-5 mt-0.5"}
        style={{ color: "var(--avt-orange, #F97316)", flexShrink: 0 }}
      />
      <div className={`${size} leading-relaxed`} style={{ color: "#7a4a2a" }}>
        <div
          className="text-[10px] uppercase tracking-widest font-semibold mb-0.5"
          style={{ color: "var(--avt-orange, #F97316)" }}
        >
          Payment protection
        </div>
        <div>
          For your protection: <strong>only pay through AddVendTour</strong>.
          On-app payments are protected by Stripe's dispute resolution.
          AddVendTour is not responsible for any transaction or agreement made
          outside the app. All on-app disputes must be filed through Stripe.
        </div>
      </div>
    </div>
  );
}
